<template>
    <div class="full-width">
        <div class="select-floor-part">
            <ul class="part-box" style="width: calc(100% - 100px)">
                <li class="color-tag free-tag">

                </li>

                <li>
                    <span class="tag-text-span" tkey="可選">{{i18n.tkey("lang_free_to_select")}}</span>
                </li>

                <li class="color-tag seleted-tag">
                    <font-awesome-icon icon="fa-solid fa-check" />
                </li>

                <li>
                    <span class="tag-text-span" tkey="已選">{{i18n.tkey("lang_already_select")}}</span>
                </li>

                <li class="color-tag reserve-tag">
                    <font-awesome-icon icon="fa-solid fa-user-check" />
                </li>

                <li>
                    <span class="tag-text-span" tkey="已訂">{{i18n.tkey("lang_already_reserve")}}</span>
                </li>

                <li class="color-tag sold-tag">
                    <font-awesome-icon icon="fa-solid fa-user" />
                </li>

                <li>
                    <span class="tag-text-span" tkey="已售">{{i18n.tkey("lang_already_sold")}}</span>
                </li>
            </ul>

            <div class="part-box" style="width: 100px">
                <el-select v-model="currFloor" @change="changeFloor">
                    <el-option v-for="(v, i) in 99"
                               :key="v"
                               :label="`${v}F`"
                               :value="v"
                    />
                </el-select>
            </div>

        </div>

        <div class="list-part-box">
            <div class="list-part" :style="{'background-image': `url(${publicPath}static/images/0240520164008.jpg)`}">
                <el-row :gutter="30" style="margin-top: 128px;transform: rotateY(180deg);">
                    <el-col :span="6" v-for="(v, i) in floorItemList" :key="v.rid" @click="clickPositionBox(v)" class="record-box">
                        <hallBoothPositionRecord :obj="v" :selectAddinfo1="selectAddinfo1" :selectAddinfo2="selectAddinfo2" />
                    </el-col>
                </el-row>
            </div>
        </div>

        <div>
            <el-button type="success" @click="submitSelect" style="width: 100%; margin-top: 20px;">
                <span tkey="確認選擇">{{i18n.tkey("lang_confirm_select")}}</span>
            </el-button>
        </div>

    </div>
</template>

<script setup>
    import hallBoothPositionRecord from "@/components/shopopee/hall/hallBoothPositionRecord"
    import {inject, onMounted, onBeforeMount, ref, computed, watch} from "vue";
    //导入图标
    import { library } from '@fortawesome/fontawesome-svg-core'
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
    import { faCheck, faUser, faUserCheck } from '@fortawesome/free-solid-svg-icons'
    import myUtil from "@/util/util";

    library.add(faCheck, faUser, faUserCheck)

    const props = defineProps(["list", "tag"])
    const emits = defineEmits(["submitSelect", "submitDel"])

    const publicPath = process.env.BASE_URL

    const i18n = inject("i18n")

    const hallBoothMap = {}
    const currFloor = ref(1)
    const floorItemList = ref([])

    const selectAddinfo1 = ref(null)
    const selectAddinfo2 = ref(null)

    const loading = ref(false)

    watch(() => props.list, (newValue, oldValue) => {
        fillHallBoothMap()
        changeFloor()
    })

    function fillHallBoothMap(){

        props.list.forEach((item, index) => {
            if (null != item.addinfo1){
                if (null == hallBoothMap[item.addinfo1]){
                    hallBoothMap[item.addinfo1] = {}
                }

                hallBoothMap[item.addinfo1][item.addinfo2] = item
            }
        })

    }

    function changeFloor(num){
        if (null != num){
            currFloor.value = num
        }

        floorItemList.value = []

        const currTimeNum = new Date().getTime()

        for (let i=1; i<=20; i++){
            if (null != hallBoothMap[currFloor.value] && null != hallBoothMap[currFloor.value][i]){
                const data = hallBoothMap[currFloor.value][i]
                data.rid = i + "" + currTimeNum

                floorItemList.value.push(hallBoothMap[currFloor.value][i])
            }else{
                floorItemList.value.push({
                    rid: i + "" + currTimeNum,
                    recordno: 0,
                    addinfo1: currFloor.value,
                    addinfo2: i
                })
            }
        }

    }

    function clickPositionBox(obj){
        if (props.tag == "admin"){
            if (obj.recordno == 1){
                myUtil.confirmWarning(i18n.tkey("lang_confirm_del_record15_text_1"), () => {
                    delRecord(obj)
                })

                return
            }else if (obj.recordno != 1 && obj.recordno != 0){
                return
            }
        }else{
            if (obj.recordno != 0){
                return
            }
        }

        if (obj.addinfo1 == selectAddinfo1.value && obj.addinfo2 == selectAddinfo2.value){
            selectAddinfo1.value = null
            selectAddinfo2.value = null
        }else{
            selectAddinfo1.value = obj.addinfo1
            selectAddinfo2.value = obj.addinfo2
        }

    }

    function delRecord(obj) {
        emits("submitDel", obj)
    }

    function submitSelect(){
        if (null == selectAddinfo1.value || null == selectAddinfo2.value){
            myUtil.alertWarning(i18n.tkey("lang_select_hall_position_pls"))
            return
        }

        emits("submitSelect", selectAddinfo1.value, selectAddinfo2.value)
        selectAddinfo1.value = null
        selectAddinfo2.value = null
    }

    onBeforeMount(() => {
        if (null != props.list){
            fillHallBoothMap()
            changeFloor()
        }
    })

    onMounted(() => {

    })

</script>

<style scoped>
    .full-width {
        width: 100%;
    }

    .list-part {
        position: absolute;
        top: 0;
        left: 0;
        background-size: contain;
        background-repeat: no-repeat; /* 防止背景图片重复 */
        background-position: center; /* 将背景图片居中 */
        margin: auto;
        box-sizing: border-box;
        width: 100%;
        height: 100%;
        padding: 10px;
        padding-left: 50px;
        padding-right: 55px;
       transform: rotate(180deg);
    }

    .record-box {
        margin-bottom: 17px;
        opacity: 0.8;
    }

    .select-floor-part {
        display: flex;
        margin-bottom: 20px;
        border-bottom: 1px #EBEEF5 solid;
        padding-bottom: 10px;
    }

    .select-floor-part .part-box {
        display: flex;
        align-items: center;
        width: 50%;
        list-style: none;
        padding-left: 0;
        margin-top: 0;
        margin-bottom: 0;
    }

    .color-tag {
        display: inline-block;
        width: 1.5em;
        height: 1.5em;
        color: #ffffff;
        line-height: 1.5em;
    }

    .seleted-tag {
        background: #67C23A;
    }

    .reserve-tag {
        background: #E6A23C;
    }

    .free-tag {
        background: #f4f4f5;
    }

    .sold-tag {
        background: #F56C6C;
    }

    .tag-text-span {
        font-size: 14px;
        color: #909399;
        margin-right: 10px;
    }

    .list-part-box {
        width: 100%;
        padding-top: 150%;
        position: relative;
    }

</style>